import React from "react";
import styled from "styled-components";
import { Environment } from "@core/config/environment";
import { Group } from "@domain/group/group";
import { mobile } from "@ui/styles/utils";
import { RoundedBlock } from "@ui/components/containers/roundedBlock";
import { DashboardHomeDetails } from "./dashboardHomeDetails";
import { ShareroomAdvise } from "./shareroomAdvise";
import { ShareroomIncome } from "./shareroomIncome";
import { ShareroomMembersCount } from "./shareroomMembersCount";

interface DashboardHomeProps extends React.HTMLAttributes<HTMLDivElement> {
	shareroom: Group;
}

export const DashboardHome: React.FC<DashboardHomeProps> = ({ shareroom, ...htmlProps }) => {
	return (
		<Container {...htmlProps}>
			<StyledCard>
				{Environment.APP_VARIANT !== "jaangal" ? <StyledShareroomIncome shareroom={shareroom} /> : null}
				<StyledShareroomAdvise shareroom={shareroom} />
				<StyledShareroomMembersCount shareroom={shareroom} />
			</StyledCard>
			<ContentBlock>
				<StyledDashboardHomeDetails shareroom={shareroom} />
			</ContentBlock>
		</Container>
	);
};

const Container = styled.div`
	display: flex;
	flex-direction: column;
`;

const StyledCard = styled.div`
	display: grid;
	grid-template: ${
		Environment.APP_VARIANT === "jaangal"
			? `"advise member" 1fr
	"main main" auto`
			: `"income advise member" 1fr
	"main main main" auto`
	};
	gap: 0px 10px;

	@media ${mobile} {
		gap: 20px 0px;
		grid-template: ${
			Environment.APP_VARIANT === "jaangal"
				? `"advise" auto
			"member" auto
			"main" auto`
				: `"income" auto
			"advise" auto
			"member" auto
			"main" auto`
		};
	}
`;

const StyledShareroomIncome = styled(ShareroomIncome)`
	grid-area: income;
`;
const StyledShareroomAdvise = styled(ShareroomAdvise)`
	grid-area: advise;
`;
const StyledShareroomMembersCount = styled(ShareroomMembersCount)`
	grid-area: member;
`;

const StyledDashboardHomeDetails = styled(DashboardHomeDetails)`
	grid-area: main;
`;

const ContentBlock = styled(RoundedBlock)`
	margin-top: 20px;
	@media ${mobile} {
		margin-top: 0px;
		margin-bottom: 20px;
		padding: 22px;
	}
`;
